ACDiscountApp.PDPage.DisplayTiers = function () {
        var storeTime = globalFields.Storetime();
      var qtyValue = 1;
  // Parse the date string into individual components
  let [currentYear, currentMonth, currentDay, currentHours, currentMinutes, currentSeconds] = storeTime.split(/[\sT:-]/);
  currentYear = parseInt(currentYear);
  currentMonth = parseInt(currentMonth); // Months are zero-based in JavaScript
  currentDay = parseInt(currentDay);
  currentHours = parseInt(currentHours);
  currentMinutes = parseInt(currentMinutes);
  currentSeconds = parseInt(currentSeconds);

  function makeTimer(end_date) {
    if (globalFields.isProduct_Page) {
      if (end_date != null) {
        jQuery("#ac_countDown").css("display", "block");
        var endTime = end_date;
        // Increment seconds by 1
        currentSeconds++;

        // Adjust minutes, hours, and day if necessary
        if (currentSeconds >= 60) {
          currentSeconds = 0;
          currentMinutes++;
          if (currentMinutes >= 60) {
            currentMinutes = 0;
            currentHours++;
            if (currentHours >= 24) {
              currentHours = 0;
              currentDay++;
            }
          }
        }

        // Reformat the updated timestamp
        let currentStoreTime = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}T${currentHours.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}:${currentSeconds.toString().padStart(2, '0')}`;
        endTime = (Date.parse(endTime) / 1000);
        var now = currentStoreTime;
        now = (Date.parse(now) / 1000);
        var timeLeft = endTime - now;
        var days = Math.floor(timeLeft / 86400);
        var hours = Math.floor(timeLeft / 3600);
        var exactHour = hours % 24;
        var minutes = Math.floor((timeLeft - (hours * 3600)) / 60);
        var seconds = Math.floor((timeLeft - (hours * 3600) - (minutes * 60)));
        var isDays = false;
        if (days > 0 || hours > 24) { isDays = true; }
        if (days < 0) { days = "00"; /*hours = "0"; minutes = "0"; seconds = "0";*/ }
        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        if (timeLeft > 0) {
          if (isDays) {
            $(".ac__days").html(days); $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes);
            $(".ac_sec, .ac__colon.seconds").hide();
          }
          else {
            $(".ac__hours").html(exactHour); $(".ac__minutes").html(minutes); $(".ac__seconds").html(seconds);
            $(".ac_day, .ac__colon.hours").hide(); $(".ac_sec, .ac__colon.seconds").show();
          }
        }
        else { jQuery('.ac__settings__table, #ac_countDown').remove(); }

        setTimeout(function () {
          jQuery('.ac__settings__table').after(jQuery("#ac_countDown"));
        }, 500);
      }
    }
  }

  var hide_buttons = null;
  var HideAdditionalPayments = function () {
    hide_buttons = setInterval(function () {
      if (jQuery('.shopify-payment-button__button').length > 0) {
        jQuery('.shopify-payment-button__button').hide();
        clearInterval(hide_buttons);
      }
    }, 500);
  }

  this.DisplayTiersFn = function () {
    setTimeout(function () {
      jQuery('.ac__settings__table').remove();
      var selectedVariant = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]').val();
      let ProductPage = globalFields.TableProductPage != undefined && globalFields.TableProductPage != '' ? globalFields.TableProductPage : 'true';
      ProductPage = ProductPage == 'true' ? true : false;
      if (globalFields.isProductPage && selectedVariant != null && globalFieldsProductPage_AC.productMetafield != '[]' && globalFieldsProductPage_AC.productMetafield != undefined && ProductPage) {
        let tierObj = globalFields.GetTierObject(globalFieldsProductPage_AC.productMetafield, selectedVariant);
        let DiscountAppliedOn = false;
        let Location_Tag_s = false;
        if (tierObj != undefined) {
          DiscountAppliedOn = tierObj.DiscountAppliedON != null && tierObj.DiscountAppliedON != '' && tierObj.DiscountAppliedON != undefined ? true : false;
          Location_Tag_s = tierObj.Location_Tag_ != null && tierObj.Location_Tag_ != '' && tierObj.Location_Tag_ != undefined ? true : false;
        }
        if (DiscountAppliedOn) {
          // 1
          if (Location_Tag_s) {
            // 2
            let DiscountAppliedOnTag = tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store' ? true : false;

            let LocationObject = Object.keys(tierObj.Location_Tag_);
            if (LocationObject[0] == 'StoreLocation') {
              let StoreLocationcheck = tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
              if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && StoreLocationcheck) {
                var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                getDates.valid; getDates.start_date; getDates.end_date;
                let timer_settings = parsed_timer_settings;
                WriteTableHeading(tierObj);
                WriteTableRows(tierObj, selectedVariant);
                if (timer_settings != undefined) {
                  if (timer_settings.TimerStatus) {
                    if (getDates.valid) {
                      setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                    }
                  }
                }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function () {
                  jQuery('.shopify-payment-button__button').hide();
                  HideAdditionalPayments();
                }, 2000);
                setTimeout(function () {
                  clearInterval(hide_buttons);
                }, 5000);
              }
            }
            else {
              // 3
              let TierLocation = tierObj.Location_Tag_[LocationObject[0]];
              let CusotmerCountryLocation = globalFields.Customercountry;
              let CusotmerCityLocation = globalFields.Customercity;
              let CustomerLocationcheck_1 = (arr, arr1) => { return arr.some(item => arr1.includes(item)) };
              let CustomerLocationcheck_2 = (arr2, arr3) => { return arr2.some(item => arr3.includes(item)) };
              let CityValue = CustomerLocationcheck_1(TierLocation, CusotmerCountryLocation);
              let CountryValue = CustomerLocationcheck_2(TierLocation, CusotmerCityLocation);

              if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && (CityValue || CountryValue)) {
                var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
                getDates.valid; getDates.start_date; getDates.end_date;
                let timer_settings = parsed_timer_settings;
                WriteTableHeading(tierObj);
                WriteTableRows(tierObj, selectedVariant);
                if (timer_settings != undefined) {
                  if (timer_settings.TimerStatus) {
                    if (getDates.valid) {
                      setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                    }
                  }
                }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function () {
                  jQuery('.shopify-payment-button__button').hide();
                  HideAdditionalPayments();
                }, 2000);
                setTimeout(function () {
                  clearInterval(hide_buttons);
                }, 5000);
              }
            }

          }
          else {
            // 4
            if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && (tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store')) {
              var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
              getDates.valid; getDates.start_date; getDates.end_date;
              let timer_settings = undefined//parsed_timer_settings;                
              WriteTableHeading(tierObj);
              WriteTableRows(tierObj, selectedVariant);
              if (timer_settings != undefined) {
                if (timer_settings.TimerStatus) {
                  if (getDates.valid) {
                    setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                  }
                }
              }
              jQuery('.shopify-payment-button__button').hide();
              setTimeout(function () {
                jQuery('.shopify-payment-button__button').hide();
                HideAdditionalPayments();
              }, 2000);
              setTimeout(function () {
                clearInterval(hide_buttons);
              }, 5000);
            }
          }
        }
        else {
          // 5
          let temptimer = globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)
          if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
            var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
            getDates.valid; getDates.start_date; getDates.end_date;
            let timer_settings = undefined//parsed_timer_settings;                
            WriteTableHeading(tierObj);
            WriteTableRows(tierObj, selectedVariant);
            if (timer_settings != undefined) {
              if (timer_settings.TimerStatus) {
                if (getDates.valid) {
                  setInterval(function () { makeTimer(getDates.end_date); }, 1000);
                }
              }
            }
            jQuery('.shopify-payment-button__button').hide();
            setTimeout(function () {
              jQuery('.shopify-payment-button__button').hide();
              HideAdditionalPayments();
            }, 2000);
            setTimeout(function () {
              clearInterval(hide_buttons);
            }, 5000);
          }
        }
      }
    }, 200);

  }


  setTimeout(function () {
    clearInterval(hide_buttons);
  }, 10000);

  this.OnVariantChange = function () {
    setTimeout(function () {
      $(".js.product-form__input label").click(function () {
        displayTiers.DisplayTiersFn();
      });
    }, 2000);
  }
   this.OnQuantityChange = function () {
        setTimeout(function () {
            $('.product__info-wrapper .quantity__input').keyup(function(){
               setTimeout(function(){  
                let qtyValuseNum = jQuery('.product__info-wrapper .quantity__input').val();
                qtyValue = Number(qtyValuseNum);
                  displayTiers.DisplayTiersFn();
              },100);
            });
            $('.product__info-wrapper button[name="minus"],.product__info-wrapper button[name="plus"]').click(function(){
              setTimeout(function(){  
                let qtyValuseNum = jQuery('.product__info-wrapper .quantity__input').val();
                qtyValue = Number(qtyValuseNum);
                  displayTiers.DisplayTiersFn();
              },100);
            });
        }, 2000);
    }
  
  var TableHeadHtml = function (contentHtml, tableSelector, position) {
    jQuery(tableSelector).before(contentHtml)
  }

  var WriteTableHeading = function (tierObj) {
    var tableSelector = '.product-form-buttons';
    jQuery('.anncodeHeading').remove();
    if (globalFields.settings.selected_table == "table1") {
      TableHeadHtml('<table class="ac__settings__table ac_table1" id="ac_table1"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th></tr></tbody></table>', tableSelector);
    }
    if (globalFields.settings.selected_table == "table2") {

      TableHeadHtml('<table class="ac__settings__table ac_table2" id="ac_table2"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th><th class="ac__th ac__th3">' + globalFields.settings.table_headers.header3_value + '</th></tr></tbody></table>', tableSelector);
    }

    if (globalFields.settings.selected_table == "table3") {
      TableHeadHtml('<h3 class="anncodeHeading" style="border-radius: 0;">Je mehr, desto günstiger!</h3><table class="ac__settings__table ac_table3" id="ac_table3"><tbody class="ac__tbody"><tr class="ac__tr ac__tr1"><th style=" border: 1px solid #f8f8f8 !important; " class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th style=" border: 1px solid #f8f8f8 !important; " class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th><th style=" border: 1px solid #f8f8f8 !important; " class="ac__th ac__th3">' + globalFields.settings.table_headers.header3_value + '</th></tr></tbody></table>', tableSelector);
    }
    if (globalFields.settings.selected_table == "table4") {
      TableHeadHtml('<table class="ac__settings__table ac_table4" id="ac_table4"><tbody class="ac__tbody"></tbody></table>', tableSelector);
    }
  }

  var TableRowHtml = function (contentHtml, tableSelector) {
    jQuery(tableSelector).append(contentHtml);
  }

  var TableRowSingle = function (tieredMin_, tieredMax_, discountedPrice, tieredOff, booleanmostPopularValues, index,lastLength,PirceoriginalPrice_,foundValue) {
    var flasgs = false;
      var conditionvalue1 = false;
      var conditionvalue2 = false;
        var minTierVal = parseInt(tieredMin_), maxTierVal = tieredMax_ != '+' ? parseInt(tieredMax_) : tieredMax_;
        conditionvalue1 = qtyValue >= minTierVal;
        conditionvalue2 = maxTierVal == "+" || qtyValue <= maxTierVal;
      if (conditionvalue1 && conditionvalue2) {
       flasgs = true;
       }
    var plusSign = tieredMin_ == tieredMax_ ? '' : '+', buyText = 'Buy ';
    var priceHtml = '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + discountedPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(discountedPrice, globalFields.amount) + '</span>';
    if (globalFields.settings.selected_table == "table1") {
      if (booleanmostPopularValues) {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '<span style=" display: none; border-radius: 52px; font-size: 12px; color: white; display: block; margin-top: 5px; background-color: #0e592d; ">Most Popular</span>' + '</td><td class="ac__td ac__td2">' + tieredOff + '</td></tr>', '#ac_table1 .ac__tbody');
      } else {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '</td><td class="ac__td ac__td2">' + tieredOff + '</td></tr>', '#ac_table1 .ac__tbody');
      }

    }
    if (globalFields.settings.selected_table == "table2") {
      if (booleanmostPopularValues) {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + '<span style=" display: none; border-radius: 52px; font-size: 12px; color: white; display: block; margin-top: 5px; background-color: #0e592d; ">Most Popular</span>' + '</td><td class="ac__td ac__td2">' + tieredMax_ + '</td><td class="ac__td ac__td3">' + tieredOff + '</td></tr>', '#ac_table2 .ac__tbody');
      } else {
        TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + '</td><td class="ac__td ac__td2">' + tieredMax_ + '</td><td class="ac__td ac__td3">' + tieredOff + '</td></tr>', '#ac_table2 .ac__tbody');
      }

    }

    if (globalFields.settings.selected_table == "table3") {
      if (booleanmostPopularValues) {
        if(lastLength == index){
          if(flasgs){
          TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '<span style=" display: none; border-radius: 52px; font-size: 12px; color: white; display: block; margin-top: 5px; background-color: #0e592d; ">Most Popular</span>' + '</td><td class="ac__td ac__td2">' + tieredOff + '</td><td class="ac__td ac__td3">' + priceHtml + '</td></tr>', '#ac_table3 .ac__tbody');
          }else{
          TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '<span style=" display: none; border-radius: 52px; font-size: 12px; color: white; display: block; margin-top: 5px; background-color: #0e592d; ">Most Popular</span>' + '</td><td class="ac__td ac__td2">' + tieredOff + '</td><td class="ac__td ac__td3">' + priceHtml + '</td></tr>', '#ac_table3 .ac__tbody');
          }
         }else{
           if(flasgs){
           TableRowHtml('<tr class="ac__tr ac__tr2"> <td class="ac__td ac__td1">1-2</td><td class="ac__td ac__td2">--</td><td class="ac__td ac__td3"><span class="money" data-currency-eur=" Ã¢â€šÂ¬2.71" data-currency="EUR">2,71 Ã¢â€šÂ¬</span></td></tr><tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' +  tieredMin_ + '-'  + (tieredMax_ ) + '<span style=" display: none; border-radius: 52px; font-size: 12px; color: white; display: block; margin-top: 5px; background-color: #0e592d; ">Most Popular</span>' + '</td><td class="ac__td ac__td2">' + tieredOff + '</td><td class="ac__td ac__td3">' + priceHtml + '</td></tr>', '#ac_table3 .ac__tbody');
          }else{
           TableRowHtml('<tr class="ac__tr ac__tr2"> <td class="ac__td ac__td1">1-2</td><td class="ac__td ac__td2">--</td><td class="ac__td ac__td3"><span class="money" data-currency-eur=" Ã¢â€šÂ¬2.71" data-currency="EUR">2,71 Ã¢â€šÂ¬</span></td></tr><tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' +  tieredMin_ + '-'  + (tieredMax_ ) + '<span style=" display: none; border-radius: 52px; font-size: 12px; color: white; display: block; margin-top: 5px; background-color: #0e592d; ">Most Popular</span>' + '</td><td class="ac__td ac__td2">' + tieredOff + '</td><td class="ac__td ac__td3">' + priceHtml + '</td></tr>', '#ac_table3 .ac__tbody');
          }
         }
        
      } else {
        if(lastLength == index){
             if(flasgs){
             TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td1">' + tieredMin_ + plusSign + '</td><td style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td2">' + tieredOff + '</td><td  style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td3">' + priceHtml + '</td></tr>', '#ac_table3 .ac__tbody');
             }else{
             TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + plusSign + '</td><td class="ac__td ac__td2">' + tieredOff + '</td><td class="ac__td ac__td3">' + priceHtml + '</td></tr>', '#ac_table3 .ac__tbody');
             }
         
        }else{
          if(index == 1){
              if(flasgs){
              TableRowHtml('<tr class="ac__tr ac__tr2"> <td class="ac__td ac__td1" >1-2</td><td class="ac__td ac__td2">--</td><td  class="ac__td ac__td3"><span class="money" data-currency-eur=" Ã¢â€šÂ¬2.71" data-currency="EUR">' +PirceoriginalPrice_ + '</span></td></tr><tr class="ac__tr ac__tr' + (index + 1) + '"> <td style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td1">' + tieredMin_ + '-'  + (tieredMax_ )+ '</td><td style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td2">' + tieredOff + '</td><td style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td3">' +  priceHtml+ '</td></tr>', '#ac_table3 .ac__tbody'); 
              }else{
                if((qtyValue == 1 || qtyValue == 2)){
                 TableRowHtml('<tr class="ac__tr ac__tr2"> <td  class="ac__td ac__td1" style="background-color: #000000 !important;color: white !important;" >1-2</td><td style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td2">--</td><td style="background-color: #000000 !important;color: white !important;"  class="ac__td ac__td3"><span class="money" data-currency-eur=" Ã¢â€šÂ¬2.71" data-currency="EUR">' +PirceoriginalPrice_ + '</span></td></tr><tr class="ac__tr ac__tr' + (index + 1) + '"> <td  class="ac__td ac__td1">' + tieredMin_ + '-'  + (tieredMax_ )+ '</td><td  class="ac__td ac__td2">' + tieredOff + '</td><td  class="ac__td ac__td3">' +  priceHtml+ '</td></tr>', '#ac_table3 .ac__tbody'); 
                }else{
                 TableRowHtml('<tr class="ac__tr ac__tr2"> <td  class="ac__td ac__td1"  >1-2</td><td  class="ac__td ac__td2">--</td><td  class="ac__td ac__td3"><span class="money" data-currency-eur=" Ã¢â€šÂ¬2.71" data-currency="EUR">' +PirceoriginalPrice_ + '</span></td></tr><tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + '-'  + (tieredMax_ )+ '</td><td class="ac__td ac__td2">' + tieredOff + '</td><td class="ac__td ac__td3">' +  priceHtml+ '</td></tr>', '#ac_table3 .ac__tbody'); 
                }
             
              }
           
          }else{
            if(flasgs){
             TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td1">' + tieredMin_ + '-'  + (tieredMax_ )+ '</td><td style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td2">' + tieredOff + '</td><td style="background-color: #000000 !important;color: white !important;" class="ac__td ac__td3">' +  priceHtml+ '</td></tr>', '#ac_table3 .ac__tbody'); 
             }else{
             TableRowHtml('<tr class="ac__tr ac__tr' + (index + 1) + '"> <td class="ac__td ac__td1">' + tieredMin_ + '-'  + (tieredMax_ )+ '</td><td class="ac__td ac__td2">' + tieredOff + '</td><td class="ac__td ac__td3">' +  priceHtml+ '</td></tr>', '#ac_table3 .ac__tbody'); 
             }
           
          }
        
        }
        
      }

    }

    if (globalFields.settings.selected_table == "table4") {
      var quantityTextTable4 = tieredMin_ + "-" + tieredMax_;
      if (tieredMax_ == "+") {
        quantityTextTable4 = tieredMin_ + "+";
      }
      TableRowHtml('<tr class="ac__tr ac__tr' + index + '"> <td class="ac__td ac__td1">' + globalFields.settings.table_body.body1_value + ' ' + tieredMin_ + ' ' + globalFields.settings.table_body.body2_value + ' ' + tieredOff + '</td></tr>', '#ac_table4');
    }


  }

  var WriteTableRows = function (tierObj, selectedVariant_) {
    var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
    var varintsId = globalFields.current_variant;
     varintsId = Number(globalFields.current_variant);
    if (isNaN(originalPrice_)) {
    var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[varintsId]; originalPrice_ = originalPrice_ / 100;
    } else {
    var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
    }
    
    
    for (i = 0; i < tierObj.tier_min.length; i++) {
      var isBreakLoop = false, tieredOff = Number(tierObj.tier_values[i]);
      var tieredMin_ = parseInt(tierObj.tier_min[i]), tieredMax_ = tierObj.tier_max[i], discountedPrice = 0;

      if (tieredMax_ != "max") {
        tieredMax_ = parseInt(tieredMax_);
      }
      else {
        tieredMax_ = "+";
      }
  
      if (tierObj.discount_type == "percentage") {
        discountedPrice = Number(originalPrice_.toFixed(2));
        var p = parseFloat(tieredOff) / 100, originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
        discountedPrice = discountedPrice - originalPriceCut_;
        if (discountedPrice <= 0) {
          discountedPrice = 0;
          tieredOff = "100%";
          isBreakLoop = true;
          tieredMax_ = "+";
        }
        else {
          discountedPrice = discountedPrice.toFixed(2);
          tieredOff = tieredOff + " % ";
        }
      }
      else if (tierObj.discount_type == "fixed_price") {
        discountedPrice = tieredOff.toFixed(2);
        tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
      }
      else {
        discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
        if (discountedPrice <= 0) {
          discountedPrice = 0;
          tieredOff = globalFields.formatMoney(originalPrice_.toFixed(2), globalFields.amount);
          isBreakLoop = true;
          tieredMax_ = "+";
        }
        else {
          discountedPrice = discountedPrice.toFixed(2);
          tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount) + " OFF";
        }
      }

      let booleanmostPopularValues = tierObj.mostPopularValues != undefined ? (tierObj.mostPopularValues[i] != undefined ? tierObj.mostPopularValues[i] : false) : false;
      let lastLength = tierObj.tier_min.length;
      let PirceoriginalPrice_ = globalFields.formatMoney(originalPrice_ * 100, globalFields.amount);
      TableRowSingle(tieredMin_, tieredMax_, discountedPrice, tieredOff, booleanmostPopularValues, i + 1,lastLength,PirceoriginalPrice_);

      if (isBreakLoop) { break; }
    }
  }

}

var globalFieldsProductPage_AC = new ACDiscountApp.PDPage.Global(), displayTiers = new ACDiscountApp.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn(); displayTiers.OnVariantChange();displayTiers.OnQuantityChange();